<div class="flex flex-col gap-4">
  <div class="flex items-center">
    <div class="text-2xl">Add organization</div>
    <button class="ml-auto" mat-icon-button matDialogClose>
      <mat-icon svgIcon="mat_outline:close"></mat-icon>
    </button>
  </div>
  <tm-organization-add-form (done)="done($event)"></tm-organization-add-form>
</div>